import { useRef } from 'react'
import { useRecoilState } from "recoil";
import { isPlayerVisibleAtom } from ".";

let autoCloseTimerId:NodeJS.Timeout = null

const usePlayerVisibility = () => {

  const [isPlayerVisible, setIsPlayerPanelVisible] = useRecoilState(isPlayerVisibleAtom);
  const isPlayerVisibleRef = useRef(isPlayerVisible);

  isPlayerVisibleRef.current = isPlayerVisible

  // Toggle the player visibility. If autoHide is enabled, the player bar will hide after 4000 milliseconds.
  const togglePlayerVisibility = ({ autoHide = false, hideDelay = 4000 }: { autoHide?: boolean, hideDelay?: number } = {}) => {
    const visible = !isPlayerVisibleRef.current
    setIsPlayerPanelVisible(visible);
    // Clear old timer
    clearTimeout(autoCloseTimerId)

    // Auto hide the player visibility after 4sec
    if(visible && autoHide) {
      autoCloseTimerId = setTimeout(() => {
        setIsPlayerPanelVisible(false);
      }, hideDelay)
    }
    
  }

    return { isPlayerVisible, togglePlayerVisibility }
}

export default usePlayerVisibility;
